import React, { CSSProperties, FC } from 'react';
import { useNavigate } from 'react-router-dom';
import screenImage from '../../assets/images/welcome-pattern.png';
import logo from '../../assets/full-logo.svg';
import { Button } from '../components/Button';
import { PressableText } from '../components/PressableText';
import { Separator } from '../components/Separator';
import { appWidth } from './CSD/WelcomeCSD';
import { Router } from '../router/Router';
import { NotAuthProvider } from '../components/NotAuthProvider';

export const Welcome: FC = () => {
  const navigation = useNavigate();
  const styles = {
    root: {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px',
    } as CSSProperties,
    bgImage: {
      height: '60%',
      position: 'fixed',
      bottom: 5,
      right: 0,
      zIndex: -1,
    } as CSSProperties,
    mainContainer: {
      width: '100%',
      maxWidth: 400,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      background: 'white',
      borderRadius: '20px',
      padding: '40px 30px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
    } as CSSProperties,
    logo: {
      width: '60%',
      maxWidth: '200px',
    } as CSSProperties,
    text: {
      width: '100%',
      textAlign: 'center',
      fontSize: '16px',
      lineHeight: '1.5',
      color: '#333',
    } as CSSProperties,
  };

  const handleSignUp = () => Router(navigation).goToSignUp();
  const handleSignIn = () => Router(navigation).goToSignIn();
  return (
    <NotAuthProvider>
      <img className="welcome-bg-image" style={styles.bgImage} src={screenImage} alt="background" />
      <div style={styles.root}>
        <div className="welcome-container" style={styles.mainContainer}>
          <img className="welcome-logo" style={styles.logo} src={logo} alt="logo" />
          <Separator size="S" />
          <span className="welcome-text" style={styles.text}>Get an Olyns account. Earn cash for recycling and help the planet.</span>
          <Separator size="M" />
          <Button type="PRIMARY" width="100%" title="Sign me up" onClick={handleSignUp} />
          <Separator size="S" />
          <PressableText width="100%" title="Already joined? Sign in!" textAlign="center" onClick={handleSignIn} />
        </div>
      </div>
    </NotAuthProvider>
  );
};
